import { ApolloClient, from, } from '@apollo/client';
import graphQLCache from './cache';
import addLangHeaderLink from './links/addLangHeaderLink';
import addTenancyHeaderLink from './links/addTenancyHeaderLink';
import { createAsyncSplitLink } from './links/asyncSplitLink';
import authLink from './links/authLink';
import handleInvalidTokenLink from './links/handleInvalidTokenLink';
import httpLink from './links/httpLink';
import { offlineServerLink, shouldResolveOffline } from './links/offlineServerLink';
import retryLink from './links/retryLink';
import studioClientIDLink from './links/studioClientIDLink';
const isLink = (link) => Boolean(link);
// Create the online links chain (existing links)
const onlineLinks = [
    authLink,
    studioClientIDLink,
    handleInvalidTokenLink,
    addLangHeaderLink,
    addTenancyHeaderLink,
    retryLink,
    httpLink,
].filter(isLink);
const onlineLinkChain = from(onlineLinks);
// Offline first, then network: when IndexedDB/Dexie fails inside offlineServerLink
// it forwards to the online chain instead of erroring the operation.
const offlineThenOnlineLink = from([offlineServerLink, onlineLinkChain]);
// Create the async split link that routes based on shouldResolveOffline
const asyncSplitLinkChain = createAsyncSplitLink({
    predicate: shouldResolveOffline,
    left: offlineThenOnlineLink,
    right: onlineLinkChain,
});
export const graphqlClient = new ApolloClient({
    link: asyncSplitLinkChain,
    cache: graphQLCache,
});
// Export the split link for external cache management if needed
export { asyncSplitLinkChain };
